// removed by extract-text-webpack-plugin
module.exports = {"conversationSection":"conversationSection---3EI62"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/ConversationSection/style.styl
// module id = O+OV
// module chunks = 89